import setPeriodDictionary from '@features/set-period/i18n/ru/set-period.dic.json';

export const setPeriod = {
  SET_PERIOD: setPeriodDictionary,
};

export const setPeriodNamespaces = Object.keys(setPeriod);
